// PNG conserva la transparencia; el tamaño de salida deja espacio para 30 grupos.
export const MAX_LOGO_BYTES = 16 * 1024;
const MAX_INPUT_BYTES = 10 * 1024 * 1024;
export const bytesDataUrl = (data) => {
  const base64 = data.slice(data.indexOf(',') + 1);
  return Math.floor(base64.length * 3 / 4) - (base64.endsWith('==') ? 2 : base64.endsWith('=') ? 1 : 0);
};
export const optimizarLogo = async (file) => {
  const formatos = ['image/png','image/jpeg','image/webp'];
  if (!(formatos.includes(file.type) || (!file.type && /\.(png|jpe?g|webp)$/i.test(file.name)))) {
    throw new Error('Formato no compatible. Selecciona una imagen PNG, JPG o WebP.');
  }
  if (!file.size || file.size > MAX_INPUT_BYTES) throw new Error('Selecciona una imagen de hasta 10 MB. El sistema la reducirá automáticamente.');
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((resolve,reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error('No se pudo abrir la imagen. Verifica que el archivo no esté dañado.'));
      image.src = url;
    });
    if (!img.naturalWidth || !img.naturalHeight || img.naturalWidth * img.naturalHeight > 40000000) {
      throw new Error('Las dimensiones de la imagen son demasiado grandes para procesarla.');
    }
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Este navegador no permite preparar imágenes. Prueba con otro navegador.');
    let lado = Math.min(320,Math.max(img.naturalWidth,img.naturalHeight));
    while (lado >= 16) {
      const scale = Math.min(1,lado / Math.max(img.naturalWidth,img.naturalHeight));
      canvas.width = Math.max(1,Math.round(img.naturalWidth * scale));
      canvas.height = Math.max(1,Math.round(img.naturalHeight * scale));
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      // Sin relleno de fondo: mantener el canal de transparencia de la imagen.
      ctx.drawImage(img,0,0,canvas.width,canvas.height);
      const data = canvas.toDataURL('image/png');
      if (!data.startsWith('data:image/png;base64,')) throw new Error('No se pudo convertir la imagen a PNG.');
      const bytes = bytesDataUrl(data);
      if (bytes <= MAX_LOGO_BYTES) return {imagen:data,bytes,ancho:canvas.width,alto:canvas.height};
      lado = Math.floor(lado * .8);
    }
    throw new Error('No se pudo reducir este logo. Prueba con una imagen más sencilla.');
  } finally { URL.revokeObjectURL(url); }
};
